import React from 'react';
import { Grid } from '@material-ui/core';
import AntSwitch from '../dailydose/AntSwitch';
import BackButton from '../common/BackButton';
import SaveButton from '../common/SaveButton';

export default function DepartmentRoleMapping({ classes, getDeptContent, getContent, backButton, submit }) {
  return (
    <>
      <Grid container direction="column" style={{ border: '1px solid #F2F2F2' }}>
        <Grid container direction="row " style={{ background: '#F4F4F4', marginBottom: '20px' }}>
          {getDeptContent()}
        </Grid>
        <Grid
          component="label"
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-end"
          style={{ width: 'auto', marginBottom: '9px' }}
        >
          <Grid item className={classes.isMandatoryText}>
            IS MANDATORY
          </Grid>
          <Grid item>
            <AntSwitch
              defaultChecked
              disabled
              onClick={(e) => {
                e.preventDefault();
              }}
              style={{ cursor: 'auto' }}
            />
          </Grid>
        </Grid>
        <Grid container direction="row">
          {getContent()}
        </Grid>
      </Grid>
      <Grid container direction="row" justifyContent="flex-end" style={{ marginTop: '10px' }}>
        <Grid item>
          <BackButton handleBack={backButton} />
        </Grid>
        <Grid item>
          <SaveButton handleSubmit={submit} />
        </Grid>
      </Grid>
    </>
  );
}
